<mat-card class="fuse-card-medium text-center">
    <mat-card-title translate>{{ this.cardTitle }}</mat-card-title>
    <div style="display: flex; flex-direction:column; justify-content: center; align-items: center;">
        <img mat-card-image src="{{this.imgUrl}}" alt="" class="matIconCardMedium" /></div>
    <mat-card-content>
        <p>{{this.cardContentTitle}}</p>
    </mat-card-content>
    <mat-card-actions>
        <button mat-button color="primary" (click)="navigate()">
            <span translate>{{this.buttonText}}</span> <mat-icon>arrow_right_alt</mat-icon>
        </button>
    </mat-card-actions>
</mat-card>